import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "src/components/Placeholder";

function HundrdFreeSpinOnGaneshGoldPromo(props: any) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK =
        brandId &&
        (brandId === 35 ||
            brandId === 36 ||
            brandId === 37 ||
            brandId === 49);

    const minQualifyingDepositAmt =
        brandId === 61
            ? "$31.60"
            : isPK
            ? "PKR 9,000"
            : "₹3,000";

    const maxBonusAmt =
        brandId === 61
            ? "$10.53"
            : isPK
            ? "PKR 3,000"
            : "₹1,000";

    return (
        <>
            <InformationWrapper>
                {/* =========================
                    TOP CONTENT
                ========================== */}
                <TopSection>
                    <h1>10 CHANCES TO DEPOSIT. 10 CHANCES TO WIN BIG.</h1>

                    <p className="top-para">
                        Make A Qualifying Deposit And Get 10 Free Spins On{" "}
                        <strong>Ganesha Gold</strong> — Instantly. Come Back And
                        Deposit
                        <br className="desktop-break" />
                        Again To Claim More: Up To 10 Times During The Promotion,
                        For Up To 100 Free Spins In Total.
                    </p>

                    <p className="promotion-period">
                        <strong>Promotion Period :</strong>{" "}
                        1 September – 31 October 2026
                    </p>
                </TopSection>

                {/* =========================
                    HOW TO CLAIM
                ========================== */}
                <Section>
                    <h2>How To Claim</h2>

                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.HundrdFreeSpinOnGaneshGoldHowToClaimImage}`}
                            alt="How To Claim"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Section>

                {/* =========================
                    TERMS & CONDITIONS
                ========================== */}
                <Section>
                    <h2>Terms & Conditions</h2>

                    <TermsList>
                        <li>
                            Promotion Is Valid From{" "}
                            <strong>
                                1 September To 31 October 2026.
                            </strong>
                        </li>

                        <li>
                            The Minimum Qualifying Deposit Is{" "}
                            <strong>{minQualifyingDepositAmt}</strong> In A Single Transaction.
                        </li>

                        <li>
                            Each Qualifying Deposit Earns{" "}
                            <strong>10 Free Spins</strong> On Ganesh Gold.
                        </li>

                        <li>
                            The Maximum Bonus Per Player Is{" "}
                            <strong>{maxBonusAmt}</strong> In Total.
                        </li>

                        <li>
                            Each Player Can Claim This Promotion A Maximum Of{" "}
                            <strong>10 Times,</strong> For Up To{" "} 100 Free Spins In Total.
                        </li>

                        <li>
                            Free Spins Are Valid For{" "}
                            <strong>24 Hours</strong> From The Time Of Credit.
                            
                        </li>

                        <li>
                            Only Qualifying Deposits Are Eligible. Cancelled,
                            Reversed Or Invalid Deposits Will Not Qualify.
                        </li>

                        <li>Regular Terms & Conditions Apply.</li>
                    </TermsList>
                </Section>
            </InformationWrapper>
        </>
    );
}

export default withTheme(
    withAppContext(HundrdFreeSpinOnGaneshGoldPromo)
);

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
    width: calc(100% - 2.4em);
    min-height: 100vh;
    height: auto;

    padding: 3rem 0 4rem;
    margin: 0 1.2em;

    display: flex;
    flex-direction: column;
    align-items: center;

    background:url(${config.imageV3Host}/static/cashsite/${theme("image.HundrdFreeSpinOnGaneshGoldPromoBg")});

    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;

    overflow: hidden;
    position: relative;

    color: #fff;

    h1,
    h2,
    p {
        margin: 0;
        padding: 0;
    }

    h1,
    h2 {
        width: 100%;

        color: #ffd700;

        text-align: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    h1 {
        font-size: 22px;
        text-transform: uppercase;
    }

    h2 {
        font-size: 20px;
        text-transform: capitalize;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 0;

        padding: 2rem 15px 3rem;

        background-position: top center;

        h1 {
            font-size: 19px;
            line-height: 28px;
        }

        h2 {
            font-size: 19px;
        }
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 17px;
            line-height: 25px;
        }

        h2 {
            font-size: 18px;
        }
    }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
    width: 100%;
    max-width: 1200px;

    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 1.7rem;

    margin-bottom: 3.8rem;

    .top-para {
        width: 100%;
        max-width: 900px;

        color: #fff;

        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;

        text-transform: capitalize;
    }

    .top-para strong {
        font-weight: 700;
    }

    .promotion-period {
        color: #fff;

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;

        text-align: center;
    }

    .promotion-period strong {
        font-weight: 700;
    }

    @media (max-width: 768px) {
        gap: 1.4rem;
        margin-bottom: 3rem;

        .top-para,
        .promotion-period {
            font-size: 14px;
            line-height: 21px;
        }

        .desktop-break {
            display: none;
        }
    }
`;

/* =========================================================
   COMMON SECTION
========================================================= */

const Section = styled.section`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: 3.5rem;

    @media (max-width: 768px) {
        margin-bottom: 2.8rem;
    }
`;

/* =========================================================
   HOW TO CLAIM IMAGE
========================================================= */

const ImageWrapper = styled.div`
    width: 61%;
    max-width: 850px;

    margin: 2rem auto 0;

    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: auto;
        display: block;
    }

    @media (max-width: 992px) {
        width: 75%;
    }

    @media (max-width: 768px) {
        width: 95%;
        margin-top: 1.5rem;
    }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
    width: 40%;
    max-width: 630px;

    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;

    gap: 10px;

    margin: 2rem auto 0;
    padding: 0;

    list-style: none;

    li {
        position: relative;

        color: #fff;
        background: rgba(58, 58, 58, 0.95);

        font-size: 16px;
        font-style: normal;
        font-weight: 400;

        text-align: left;

        line-height: 25px;
        text-transform: capitalize;

        padding: 10px 1.5rem 10px 2.7rem;
    }

    li::before {
        content: "✦";

        position: absolute;

        left: 1.5rem;
        top: 10px;

        color: #fff;

        font-size: 13px;
    }

    li strong {
        font-weight: 700;
    }

    @media (max-width: 992px) {
        width: 60%;
    }

    @media (max-width: 768px) {
        width: 90%;

        margin-top: 1.5rem;

        li {
            font-size: 14px;
            line-height: 22px;

            padding: 10px 14px 10px 34px;
        }

        li::before {
            left: 15px;
        }
    }

    @media (max-width: 480px) {
        width: 95%;

        li {
            font-size: 13px;
            line-height: 20px;
        }
    }
`;